import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ef2d67f2&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef2d67f2')) {
      api.createRecord('ef2d67f2', component.options)
    } else {
      api.reload('ef2d67f2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ef2d67f2&lang=pug", function () {
      api.rerender('ef2d67f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/account/myAccountLink/index.vue"
export default component.exports